import AdminCategoryPageEditor from "@/components/admin/AdminCategoryPageEditor";
export default function AdminEGuideMateri() {
  return <AdminCategoryPageEditor pageKey="e-guide-materi" pageTitle="Halaman: E-Guide & Materi" previewPath="/kategori/e-guide-materi" />;
}
